module.exports = "/_next/static/images/prefooter-youtube@2x_7e0a0e4d8472946a90f43307b3b9d403.png";